/**
 * Shared feature flag constants
 * These flags are used across multiple libraries and applications
 */

export const BTX_EDIT_CARRIERS = "btx-edit-carriers";
